import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import EmployeeReceipts from './pages/employee/Receipts';
import NewReceipt from './pages/employee/NewReceipt';
import AdminMonths from './pages/admin/Months';
import AdminMonthUsers from './pages/admin/MonthUsers';
import UserReceipts from './pages/admin/UserReceipts';
import AdminExport from './pages/admin/Export';
import type { Role } from './types';

function Private({ children, roles }: { children: JSX.Element; roles?: Role[] }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-8 text-slate-500">Yükleniyor…</div>;
  if (!user) return <Navigate to="/giris" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function Home() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/giris" replace />;
  return <Navigate to={user.role === 'admin' ? '/yonetim/donemler' : '/fisler'} replace />;
}

export default function App() {
  return (
    <Routes>
      <Route path="/giris" element={<Login />} />

      <Route
        path="/fisler"
        element={
          <Private roles={['employee']}>
            <Layout><EmployeeReceipts /></Layout>
          </Private>
        }
      />
      <Route
        path="/fisler/yeni"
        element={
          <Private roles={['employee']}>
            <Layout><NewReceipt /></Layout>
          </Private>
        }
      />

      <Route
        path="/yonetim/donemler"
        element={
          <Private roles={['admin']}>
            <Layout><AdminMonths /></Layout>
          </Private>
        }
      />
      <Route
        path="/yonetim/donemler/:month"
        element={
          <Private roles={['admin']}>
            <Layout><AdminMonthUsers /></Layout>
          </Private>
        }
      />
      <Route
        path="/yonetim/donemler/:month/kullanicilar/:id"
        element={
          <Private roles={['admin']}>
            <Layout><UserReceipts /></Layout>
          </Private>
        }
      />
      <Route
        path="/yonetim/excel"
        element={
          <Private roles={['admin']}>
            <Layout><AdminExport /></Layout>
          </Private>
        }
      />

      <Route path="*" element={<Home />} />
    </Routes>
  );
}
